import { createSelector } from '@reduxjs/toolkit'
import moment from 'moment'
import { selectors as commonSelectors } from 'shared/store'
import { parseToSafariDateTime } from 'shared/utils'
import { Subscription, ProductType, AnyProduct } from 'shared/types'

export const getNewSubscriptionExpirationDate = createSelector(
  commonSelectors.users.getCurrentSubscriptionState,
  commonSelectors.payments.getSelectedProduct,
  ({ data }, product) => {
    const baseExpirationDate =
      typeof data?.subscription?.nextPaymentDate === 'string'
        ? new Date(parseToSafariDateTime(data.subscription.nextPaymentDate))
        : new Date()
    const months =
      (product as AnyProduct)?.type === ProductType.Subscription
        ? (product as Subscription).lengthInMonths
        : 0

    return moment(baseExpirationDate).add(months, 'months')
  }
)
